import React from 'react'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {
    Box,
    List,
    ListItem,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    BENEFITS_1_ROW1,
    BENEFITS_1_ROW2,
    BENEFITS_2_ROW1,
    BENEFITS_2_ROW2,
    BENEFITS_3_ROW1,
    BENEFITS_3_ROW2,
    BENEFITS_4_ROW1,
    BENEFITS_4_ROW2
} from '@consteed/overrides/i18n/components/pageDesigner/Benefits'

const benefitBgImage = getAssetUrl('static/img/landingPageDiscover/benefitsCircle.png')
const Benefit = (props) => {
    return (
        <ListItem {...props.styles} bgImage={`url(${benefitBgImage})`}>
            <Box as="p" lineHeight={4}>
                {props.children}
            </Box>
        </ListItem>
    )
}
Benefit.propTypes = {
    children: PropTypes.object,
    styles: PropTypes.object
}

const Benefits = ({hasLightBg = false}) => {
    const styles = useMultiStyleConfig('Benefits', {hasLightBg})
    const {formatMessage} = useIntl()
    const benefitsStrings = [
        {row1: BENEFITS_1_ROW1, row2: BENEFITS_1_ROW2},
        {row1: BENEFITS_2_ROW1, row2: BENEFITS_2_ROW2},
        {row1: BENEFITS_3_ROW1, row2: BENEFITS_3_ROW2},
        {row1: BENEFITS_4_ROW1, row2: BENEFITS_4_ROW2}
    ]
    return (
        <List {...styles.benefitsList}>
            {benefitsStrings.map((benefit, index) => (
                <Benefit styles={styles.benefitsListItem} key={`benefit${index}`}>
                    <React.Fragment>
                        <Box as="strong" fontSize="15px">
                            {formatMessage(benefit.row1)}
                        </Box>
                        <br />
                        <Box as="strong" fontSize="xs">
                            {formatMessage(benefit.row2)}
                        </Box>
                    </React.Fragment>
                </Benefit>
            ))}
        </List>
    )
}
Benefits.propTypes = {
    hasLightBg: PropTypes.bool
}
export default Benefits
